(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Queue_credit', Queue_credit);

    Queue_credit.$inject = ['$resource'];

    function Queue_credit ($resource) {
        var resourceUrl =  'api/queue-credits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
